import { ChangeDetectionStrategy, Component, Inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContainerBase } from '@fi-shared/fi-dialogs/fi-dialogs-container-base';
import { FI_DIALOGS_CONTENT_DATA, FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { MatDialogRef } from '@angular/material/dialog';
import { ContentLanguagesService } from '../../utilities/fi-services/content-languages.service';

@Component({
    selector: 'fi-document-dialog-absent-content-language',
    template: `
        <div class="dialog-text">{{ data.messageText }}</div>
        
        <div class="dialog-select">
          <mat-radio-group [(ngModel)]="selectedLanguageId">
            @for (lang of languages; track lang) {
              <mat-radio-button [value]="lang.Id">
                {{ lang.Name }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
        `,
    styleUrls: ['./dialog-absent-content-language.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-document-dialog-absent-content-language' },
    standalone: false,
})
export class DocumentDialogAbsentContentLanguageComponent
    extends FiDialogsContentBase<{ langIds: number[] }, number>
    implements OnInit
{
    languages = [];
    selectedLanguageId: number;

    constructor(
        public dialogRef: MatDialogRef<FiDialogsContainerBase<{ langIds: number[]; messageText: string }, number>>,
        public contentLanguagesService: ContentLanguagesService,
        @Inject(FI_DIALOGS_CONTENT_DATA) public data: { langIds: number[]; messageText: string },
        injector: Injector,
    ) {
        super(dialogRef, data, injector);
    }

    ngOnInit() {
        this.updateLanguagesList();
    }

    updateLanguagesList() {
        this.languages = this.contentLanguagesService
            .GetContentLanguages()
            .filter((lang) => this.data.langIds.indexOf(lang.Id) > -1);
        if (this.languages.length === 0) this.languages.push(this.contentLanguagesService.GetDefaultLanguage());

        this.selectedLanguageId = this.languages[0].Id;
    }

    getResult() {
        return this.selectedLanguageId;
    }
}
